const calcDistance = (lat1, lng1, lat2, lng2) => {
	const φ1 = (lat1 * Math.PI) / 180;
	const φ2 = (lat2 * Math.PI) / 180;
	const Δλ = ((lng2 - lng1) * Math.PI) / 180;
	const R = 6371e3;
	const d = Math.acos(Math.sin(φ1) * Math.sin(φ2) + Math.cos(φ1) * Math.cos(φ2) * Math.cos(Δλ)) * R;
	return Math.floor(d / 1000);
};

export { calcDistance };
export default calcDistance;
